export type AssetClass = 'equity' | 'commodity' | 'crypto' | 'index' | 'forex' | 'etf';

const COMMODITY = /=F$/i;
const CRYPTO = /-(USD|USDT|EUR)$/i;
const INDEX = /^\^/;
/** Yahoo `EURUSD=X`, EODHD-style `EURUSD.FOREX`, or compact `EURUSD`. */
const FOREX = /^(?:[A-Z]{6}=X|[A-Z]{6}\.FOREX|[A-Z]{6})$/;

export function guessAssetClass(symbol: string): AssetClass {
  const s = symbol.trim().toUpperCase();
  if (!s) return 'equity';
  if (COMMODITY.test(s)) return 'commodity';
  if (CRYPTO.test(s) || s === 'BTCUSD' || s === 'ETHUSD') return 'crypto';
  if (INDEX.test(s)) return 'index';
  if (FOREX.test(s)) return 'forex';
  return 'equity';
}

export const ASSET_CLASSES: AssetClass[] = ['equity', 'commodity', 'crypto', 'index', 'forex', 'etf'];
